var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavReceiptIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 -6.20866e-06H1.99999C1.86658 -0.00802585 1.73298 0.0123458 1.60802 0.0597638C1.48306 0.107182 1.36958 0.180567 1.27508 0.275075C1.18057 0.369583 1.10718 0.483063 1.05976 0.608023C1.01235 0.732983 0.991974 0.86658 0.999994 0.999994V16L3.99999 14L5.99999 16L7.99999 14L9.99999 16L12 14L15 16V0.999994C15.008 0.86658 14.9876 0.732983 14.9402 0.608023C14.8928 0.483063 14.8194 0.369583 14.7249 0.275075C14.6304 0.180567 14.5169 0.107182 14.392 0.0597638C14.267 0.0123458 14.1334 -0.00802585 14 -6.20866e-06ZM7.99999 9.99999H3.99999V7.99999H7.99999V9.99999ZM7.99999 5.99999H3.99999V3.99999H7.99999V5.99999ZM11 9.99999C10.8022 9.99999 10.6089 9.94134 10.4444 9.83146C10.28 9.72158 10.1518 9.5654 10.0761 9.38268C10.0004 9.19995 9.98062 8.99888 10.0192 8.8049C10.0578 8.61092 10.153 8.43274 10.2929 8.29289C10.4327 8.15303 10.6109 8.05779 10.8049 8.01921C10.9989 7.98062 11.2 8.00043 11.3827 8.07611C11.5654 8.1518 11.7216 8.27997 11.8315 8.44442C11.9413 8.60887 12 8.80221 12 8.99999C12 9.26521 11.8946 9.51956 11.7071 9.7071C11.5196 9.89464 11.2652 9.99999 11 9.99999ZM11 5.99999C10.8022 5.99999 10.6089 5.94134 10.4444 5.83146C10.28 5.72158 10.1518 5.5654 10.0761 5.38268C10.0004 5.19995 9.98062 4.99888 10.0192 4.8049C10.0578 4.61092 10.153 4.43274 10.2929 4.29289C10.4327 4.15303 10.6109 4.05779 10.8049 4.01921C10.9989 3.98062 11.2 4.00043 11.3827 4.07611C11.5654 4.1518 11.7216 4.27997 11.8315 4.44442C11.9413 4.60887 12 4.80221 12 4.99999C12 5.26521 11.8946 5.51956 11.7071 5.7071C11.5196 5.89464 11.2652 5.99999 11 5.99999Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 4,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 4,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 5,
    r: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 9,
    r: 1,
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavReceiptIcon);
export default __webpack_public_path__ + "static/media/nav-receipt-icon.89d4288c.svg";
export { ForwardRef as ReactComponent };